import { useEffect, useState } from 'react';
import { fetchDashboardData } from '../../../services/api';

function useDashboardData() {
  const [dashboard, setDashboard] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let mounted = true;
    fetchDashboardData()
      .then((data) => {
        if (mounted) setDashboard(data);
      })
      .catch((requestError) => {
        if (mounted) setError(requestError.message);
      })
      .finally(() => {
        if (mounted) setLoading(false);
      });

    return () => { mounted = false; };
  }, []);

  return { dashboard, loading, error };
}

export default useDashboardData;